import { put, takeLatest } from 'redux-saga/effects';
import { createAppTableSaga, createAppTableStore } from 'components/AppTable/store';
import apiRoutes from 'config/apiRoute';
import { convertMinsToHrsMins } from 'utils/string.utils';
import { toTimeEntriesParams } from 'services/timeTracking/tableParams';

export const projectTimelogReportSlice = createAppTableStore({
  name: 'projectTimelogReport' as const,
  url: apiRoutes.TIME_ENTRIES,
  initialState: {
    params: {
      filters: {
        user_uuid: [],
        user_type: [{ value: 'regular_user' }, { value: 'freelancer' }],
        source: [{ value: 'task' }, { value: 'request' }],
        category: [{ value: 'billable' }, { value: 'non-billable' }, { value: 'sgm-non-billable' }],
        project_type: [{ value: 'retainer' }, { value: 'hosting' }, { value: 'others' }],
        request_uuid: [],
      },
    },
    apiParamsHandler: toTimeEntriesParams,
    totalTime: null as null | string,
  },
  reducers: {
    setTotalTime: (state, { payload }: { payload: string }) => {
      state.totalTime = payload;
    },
  },
});

function* handleApiResponseSagaListener({ payload }: { payload: any }) {
  yield put(projectTimelogReportSlice.actions.setTotalTime(convertMinsToHrsMins(Number(payload?.meta?.total_minutes ?? 0))));
}

export const projectTimelogReportSaga = createAppTableSaga(projectTimelogReportSlice, function* customGenerator() {
  yield takeLatest(projectTimelogReportSlice.actions.handleApiResponse, handleApiResponseSagaListener);
});

export const projectTimelogReportReducer = projectTimelogReportSlice.reducer;
